import React, { memo, useState, useContext } from 'react';

import { AppContext } from 'App';

import './FAQ.scss';

const FAQ = () => {
  const { pageData } = useContext(AppContext);
  const { title, list } = pageData?.faqs;
  const [accordionOpenIndex, setAccordionOpenIndex] = useState(0);

  const handleArrowClick = (index) => {
    index === accordionOpenIndex ? setAccordionOpenIndex(null) : setAccordionOpenIndex(index);
  };

  const [expanded, setExpanded] = useState(false);
  // const [indexValue, setIndexValue] = useState(2);
  const [visibleItems, setVisibleItems] = useState(3);

  const expandedHandler = () => {
    // if (!expanded) {
    //   setIndexValue(list.length);
    // } else {
    //   setIndexValue(2);
    // }
    // setExpanded(!expanded);
    if (!expanded) {
      setVisibleItems(list?.length);
    } else {
      setVisibleItems(3);
    }
    setExpanded(!expanded); 
  };
  return (
    <section id="faqSection" className="faq_section">
      <div className="container">
        <h2>{title}</h2>
        <div className="accordion-cards">
          {list
            // ?.filter((_, pIndex) => pIndex <= indexValue)
            .map((item, index) => (
              <div className={`expansion-panel ${index < visibleItems ? 'show' : 'hide'}`} key={item?.id}>
                <h3 className="active" onClick={() => handleArrowClick(index)}>
                  {item?.title}
                  <span className={'material-icons arrow-icon'}>{accordionOpenIndex === index ? 'keyboard_arrow_down' : 'expand_less'}</span>
                </h3>
                <div className={`content ${accordionOpenIndex === index ? 'show' : 'hide'}`}>
                  {item?.subTitle?.map((paragraphData, pIdx) => (
                    <p key={pIdx} dangerouslySetInnerHTML={{ __html: paragraphData }}></p>
                  ))}
                  {item?.listItems && (
                    <ul className="sub_items">
                      {item.listItems.map((subData, i) => (
                        <li key={i}>{subData.item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          <div className="view_wrapper">
            <span className="pointer_view" onClick={() => expandedHandler()}>
              {expanded ? 'View Less' : 'View More'}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(FAQ);
